// import { motion } from "framer-motion";
// import logo from "../../assets/new images/logo.png";
// export default function ThemedLoader({ logo = "/logo.svg", note = "AI-Powered Career Guidance" }) {
//   return (
//     <div
//       className="fixed inset-0 z-[9999] grid place-items-center bg-slate-900/70 backdrop-blur-md"
//       role="status"
//       aria-busy="true"
//       aria-live="polite"
//     >
//       {/* soft vignette */}


//       <div className="">
//         {/* pill */}
//         <div className="mx-auto mb-6 w-max select-none rounded-full bg-slate-900/50 px-3 py-1 text-xs font-semibold text-slate-200 ring-1 ring-white/10">
//           ✨ {note}
//         </div>

//         {/* spinner with logo chip */}
//         <div className="mx-auto grid place-items-center gap-5">
//           <div className="relative h-24 w-24">
//             {/* static ring */}
//             <div className="absolute inset-0 rounded-full border-4 border-cyan-300/25" />
//             {/* animated ring */}
//             <div className="absolute inset-0 rounded-full border-4 border-t-transparent border-orange-600 animate-spin" style={{animationDuration:'1.1s'}}/>
//             {/* accent arc */}
//             <motion.span
//               className="absolute -top-1 left-1/2 h-3 w-8 -translate-x-1/2 rounded-full bg-gradient-to-r from-orange-400 to-cyan-400 blur-[2px]"
//               animate={{ rotate: 360 }}
//               transition={{ repeat: Infinity, duration: 2.2, ease: "linear" }}
//             />
//             {/* center chip with logo */}
//             <div className="absolute inset-2 grid place-items-center rounded-full bg-white/10 backdrop-blur-md ring-1 ring-white/20">
//               {logo ? (
//                 <img src={logo} alt="Brand" className="h-8 opacity-90" />
//               ) : (
//                 <span className="text-xl font-bold text-white/90">AI</span>
//               )}
//             </div>
//           </div>

    
//         </div>
//       </div>
//     </div>
//   );
// }



import { motion } from "framer-motion";

export default function ThemedLoader({
  logo = "/logo.svg",
  note = "AI-Powered Career Guidance",
  className = "", // <-- allows fade-out from parent
}) {
  return (
    <div
      className={`fixed inset-0 z-[9999] grid place-items-center bg-slate-900/70 backdrop-blur-md ${className}`}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <div>
        {/* pill */}
        <div className="mx-auto mb-6 w-max select-none rounded-full bg-slate-900/50 px-3 py-1 text-xs font-semibold text-slate-200 ring-1 ring-white/10">
          ✨ {note}
        </div>

        {/* spinner with logo chip */}
        <div className="mx-auto grid place-items-center gap-5">
          <div className="relative h-24 w-24">
            {/* static ring */}
            <div className="absolute inset-0 rounded-full border-4 border-cyan-300/25" />
            {/* animated ring */}
            <div
              className="absolute inset-0 rounded-full border-4 border-t-transparent border-orange-600 animate-spin"
              style={{ animationDuration: "1.1s" }}
            />
            {/* accent arc */}
            <motion.span
              className="absolute -top-1 left-1/2 h-3 w-8 -translate-x-1/2 rounded-full bg-gradient-to-r from-orange-400 to-cyan-400 blur-[2px]"
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 2.2, ease: "linear" }}
            />
            {/* center chip with logo */}
            <div className="absolute inset-2 grid place-items-center rounded-full bg-white/10 backdrop-blur-md ring-1 ring-white/20">
              {logo ? (
                <img src={logo} alt="Brand" className="h-8 opacity-90" />
              ) : (
                <span className="text-xl font-bold text-white/90">AI</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
